import React, { version } from 'react';
import './App.css';
import axios from 'axios';

class EndPoint {
  constructor(url, version) {
    this.url = url
    this.url_version = url === "" ? "" : url + '/version'
    this.url_config = url === "" ? "" : url+'/config'
    this.version = version
  }
} 

class EnvironmentEndPoints {
  constructor(pps, hubTvSupportApi, ipLocation, saml, sessionRuleService, ppvService, activationPortal) {
    this.pps = new EndPoint(pps, pps === "" ? "-" : "?")
    this.hubTvSupportApi = new EndPoint(hubTvSupportApi, hubTvSupportApi === "" ? "-" : "?")
    this.ipLocation = new EndPoint(ipLocation, ipLocation === "" ? "-" : "?")
    this.saml = new EndPoint(saml, saml === "" ? "-" : "?")
    this.sessionRuleService = new EndPoint(sessionRuleService, sessionRuleService === "" ? "-" : "?")
    this.ppvService = new EndPoint(ppvService, ppvService === "" ? "-" : "?")
    this.activationPortal = new EndPoint(activationPortal, activationPortal === "" ? "-" : "?")
  }
}

const ppsCurrentVersion = '7.1.0'
const ipLocationCurrentVersion = '2.8.1' // 2.1.1
const hubTvSupportApiCurrentVersion = '3.11.0'
const samlCurrentVersion = '2.0.24'
const sessionRuleServiceCurrentVersion = '0.3.3' 
const ppvServiceCurrentVersion = '0.3.2'
const activationPortalCurrentVersion = '0.1.45'

const lprStagingEndPointsOnPrem = new EnvironmentEndPoints(
  "http://bo-stg-lpr.mw.columbuscdn.com/pps",                // PPS
  "http://172.28.8.220:9206",                                // HSA
  "http://bo-stg-lpr.mw.columbuscdn.com/ip-location",        // IP Location
  "http://bo-stg-lpr.mw.columbuscdn.com/idp",                // SAML
  "http://bo-stg-lpr.mw.columbuscdn.com/lla_session_rule",   // Session Rule Service
  "http://bo-stg-lpr.mw.columbuscdn.com/lla_ppv_service",    // PPV Service
  "http://bo-stg-lpr.mw.columbuscdn.com/activation-portal")  // Activation Portal

const lprProductionEndPointsOnPrem = new EnvironmentEndPoints(
  "http://pps.columbuscdn.com:9200",
  "http://172.28.8.220:9208",
  "http://190.242.31.92:9201",
  "http://saml.columbuscdn.com:9202",
  "",
  "",    // PPV Service
  "http://activatuhub.libertypr.com")    // Activation Portal

const cwpStagingEndPointsOnPrem = new EnvironmentEndPoints(
  "http://bo-stg-cwp.mw.columbuscdn.com/pps",
  "http://172.28.8.220:9305",
  "http://bo-stg-cwp.mw.columbuscdn.com/ip-location",
  "http://bo-stg-cwp.mw.columbuscdn.com/idp",
  "http://bo-stg-cwp.mw.columbuscdn.com/lla_session_rule",
  "http://bo-stg-cwp.mw.columbuscdn.com/lla_ppv_service",    // PPV Service
  "http://bo-stg-cwp.mw.columbuscdn.com/activation-portal")  // Activation Portal

const cwpProductionEndPointsOnPrem = new EnvironmentEndPoints(
  "http://pps.columbuscdn.com:9400",
  "http://172.28.8.220:9405",
  "http://190.242.31.92:9401",
  "",
  "",
  "",    // PPV Service
  "http://activa.masmovilpanama.com")    // Activation Portal

// const vtrStagingEndPointsOnPrem = new EnvironmentEndPoints(
//   "https://vtr-pps-staging.apps.mw.columbuscdn.com",
//   "http://172.28.8.220:9706",
//   "https://vtr-ip-location-staging.apps.mw.columbuscdn.com",
//   "https://vtr-ip-saml-staging.apps.mw.columbuscdn.com",
//   "http://lla-session-rule-vtr-stg.apps.mw.columbuscdn.com",
//   "",    // PPV Service
//   "")    // Activation Portal

  const vtrStaging2EndPointsOnPrem = new EnvironmentEndPoints(
    "",
    "",
    "",
    "",
    "",
    "",    // PPV Service
    "")    // Activation Portal

// const vtrProductionEndPointsOnPrem = new EnvironmentEndPoints(
//   "https://vtr-pps-production.apps.mw.columbuscdn.com",
//   "http://172.28.8.220:9708",
//   "http://vtr-ip-location-production.apps.mw.columbuscdn.com",
//   "https://vtr-ip-saml-production.apps.mw.columbuscdn.com",
//   "",
//   "",    // PPV Service
//   "")    // Activation Portal

const ctStagingEndPointsOnPrem = new EnvironmentEndPoints(
  "http://bo-stg-ct.mw.columbuscdn.com/pps",
  "http://172.28.8.220:9506",
  "http://bo-stg-ct.mw.columbuscdn.com/ip-location",
  "http://bo-stg-ct.mw.columbuscdn.com/idp",
  "http://bo-stg-ct.mw.columbuscdn.com/lla_session_rule",
  "http://bo-stg-ct.mw.columbuscdn.com/lla_ppv_service",    // PPV Service
  "")    // Activation Portal

const ctProductionEndPointsOnPrem = new EnvironmentEndPoints(
  "http://pps.mw.columbuscdn.com:9600",
  "http://172.28.8.220:9508",
  "http://190.242.31.92:9601",
  "http://saml.mw.columbuscdn.com:9602",
  "",
  "",    // PPV Service
  "")    // Activation Portal

const caribbeanStagingEndPointsOnPrem = new EnvironmentEndPoints(
  "http://bo-stg-flow.mw.columbuscdn.com/pps",
  "http://172.28.8.220:9512",
  "http://bo-stg-flow.mw.columbuscdn.com/ip-location",
  "http://bo-stg-flow.mw.columbuscdn.com/idp",
  "http://bo-stg-flow.mw.columbuscdn.com/lla_session_rule",
  "http://bo-stg-flow.mw.columbuscdn.com/lla_ppv_service",    // PPV Service
  "")    // Activation Portal

const caribbeanProductionEndPointsOnPrem = new EnvironmentEndPoints(
  "http://bo-prod-flow.mw.columbuscdn.com/pps",
  "",
  "http://bo-prod-flow.mw.columbuscdn.com/ip-location",
  "",
  "http://bo-prod-flow.mw.columbuscdn.com/lla_session_rule",
  "http://bo-prod-flow.mw.columbuscdn.com/lla_ppv_service",    // PPV Service
  "")    // Activation Portal

///////////////////////////////////////////////

const lprStagingEndPointsCloud = new EnvironmentEndPoints(
  "https://pps.lpr-stg.llabo-hubtv.com",         // PPS
  "https://hsa.lpr-stg.llabo-hubtv.com",         // HSA
  "https://ip-location.lpr-stg.llabo-hubtv.com", // IP Location
  "",                                            // SAML
  "https://sra.lpr-stg.llabo-hubtv.com",         // Session Rule Service
  "https://ppv.lpr-stg.llabo-hubtv.com",         // PPV Service
  "https://ap.lpr-stg.llabo-hubtv.com")          // Activation Portal

const lprProductionEndPointsCloud = new EnvironmentEndPoints(
  "https://pps.lpr-prd.llabo-hubtv.com",         // PPS
  "https://hsa.lpr-prd.llabo-hubtv.com",         // HSA
  "https://ip-location.lpr-prd.llabo-hubtv.com", // IP Location
  "",                                            // SAML
  "",         // Session Rule Service
  "https://ppv.lpr-prd.llabo-hubtv.com",         // PPV Service
  "https://ap.lpr-prd.llabo-hubtv.com")          // Activation Portal

const cwpStagingEndPointsCloud = new EnvironmentEndPoints(
  "https://pps.cwp-stg.llabo-hubtv.com",         // PPS
  "https://hsa.cwp-stg.llabo-hubtv.com",         // HSA
  "https://ip-location.cwp-stg.llabo-hubtv.com", // IP Location
  "",                                            // SAML
  "https://sra.cwp-stg.llabo-hubtv.com",         // Session Rule Service
  "",                                            // PPV Service
  "https://ap.cwp-stg.llabo-hubtv.com")          // Activation Portal

const cwpProductionEndPointsCloud = new EnvironmentEndPoints(
  "https://pps.cwp-prd.llabo-hubtv.com",         // PPS
  "https://hsa.cwp-prd.llabo-hubtv.com",         // HSA
  "https://ip-location.cwp-prd.llabo-hubtv.com", // IP Location
  "",                                            // SAML
  "https://sra.cwp-prd.llabo-hubtv.com",         // Session Rule Service
  "",         // PPV Service
  "https://ap.cwp-prd.llabo-hubtv.com")          // Activation Portal

const vtrStagingEndPointsCloud = new EnvironmentEndPoints(
  "https://pps.vtr-stg.llabo-hubtv.com",         // PPS
  "https://hsa.vtr-stg.llabo-hubtv.com",         // HSA
  "https://ip-location.vtr-stg.llabo-hubtv.com", // IP Location
  "",                                            // SAML
  "https://sra.vtr-stg.llabo-hubtv.com",         // Session Rule Service
  "",                                            // PPV Service
  "")    // Activation Portal

const vtrProductionEndPointsCloud = new EnvironmentEndPoints(
  "https://pps.vtr-prd.llabo-hubtv.com",         // PPS
  "https://hsa.vtr-prd.llabo-hubtv.com",         // HSA
  "https://ip-location.vtr-prd.llabo-hubtv.com", // IP Location
  "",                                            // SAML
  "https://sra.vtr-prd.llabo-hubtv.com",         // Session Rule Service
  "",         // PPV Service
  "")    // Activation Portal

const ctStagingEndPointsCloud = new EnvironmentEndPoints(
  "https://pps.ct-stg.llabo-hubtv.com",         // PPS
  "https://hsa.ct-stg.llabo-hubtv.com",         // HSA
  "https://ip-location.ct-stg.llabo-hubtv.com", // IP Location
  "",                                           // SAML
  "",                                           // Session Rule Service
  "",                                           // PPV Service
  "https://activacionqa.libertycr.com")         // Activation Portal

const ctProductionEndPointsCloud = new EnvironmentEndPoints(
  "https://pps.ct-prd.llabo-hubtv.com",         // PPS
  "https://hsa.ct-prd.llabo-hubtv.com",         // HSA
  "https://ip-location.ct-prd.llabo-hubtv.com", // IP Location
  "",                                           // SAML
  "",         // Session Rule Service
  "",         // PPV Service
  "https://activacion.libertycr.com")           // Activation Portal

const caribbeanStagingEndPointsCloud = new EnvironmentEndPoints(
  "https://pps.flow-stg.llabo-hubtv.com",         // PPS
  "https://hsa.flow-stg.llabo-hubtv.com",         // HSA
  "https://ip-location.flow-stg.llabo-hubtv.com", // IP Location
  "",                                             // SAML
  "https://sra.flow-stg.llabo-hubtv.com",         // Session Rule Service
  "",                                             // PPV Service
  "https://ap.flow-stg.llabo-hubtv.com")          // Activation Portal

const caribbeanProductionEndPointsCloud = new EnvironmentEndPoints(
  "https://pps.flow-prd.llabo-hubtv.com",         // PPS
  "https://hsa.flow-prd.llabo-hubtv.com",         // HSA
  "https://ip-location.flow-prd.llabo-hubtv.com", // IP Location
  "",                                             // SAML
  "https://sra.flow-prd.llabo-hubtv.com",         // Session Rule Service
  "",                                             // PPV Service
  "https://ap.flow-prd.llabo-hubtv.com")          // Activation Portal

  const llaInnoLabEndPointsCloud = new EnvironmentEndPoints(
    "https://pps.lla-innolab.llabo-hubtv.com",         // PPS
    "https://hsa.lla-innolab.llabo-hubtv.com",         // HSA
    "https://ip-location.lla-innolab.llabo-hubtv.com", // IP Location
    "",                                                // SAML
    "https://sra.lla-innolab.llabo-hubtv.com",         // Session Rule Service
    "",                                                // PPV Service
    "")                                                // Activation Portal

///////////////////////////////////////////////

const vtrStagingEndPointsCloud2 = new EnvironmentEndPoints(
  "https://pps.stg.clbo-hubtv.com",         // PPS
  "https://hsa.stg.clbo-hubtv.com",         // HSA
  "https://ip-location.stg.clbo-hubtv.com", // IP Location
  "https://samlidp-vtr-stg.alt.clbo-hubtv.com", // SAML
  "https://sra.stg.clbo-hubtv.com",         // Session Rule Service
  "",                                       // PPV Service
  "")    // Activation Portal

const vtrProductionEndPointsCloud2 = new EnvironmentEndPoints(
  "https://pps.prd.clbo-hubtv.com",         // PPS
  "https://hsa.prd.clbo-hubtv.com",         // HSA
  "https://ip-location.prd.clbo-hubtv.com", // IP Location
  "https://samlidp-prd.clbo-hubtv.com",     // SAML (VPN connected VPC Ohio) Alias: "https://samlidp-vtr-prd.alt.clbo-hubtv.com"
  "https://sra.prd.clbo-hubtv.com",         // Session Rule Service
  "",         // PPV Service
  "https://ap-vtr-prd.alt.clbo-hubtv.com")  // Activation Portal (VPN connected VPC Ohio)

  const claroStagingEndPointsCloud = new EnvironmentEndPoints(
    "https://pps.claro-stg.clbo-hubtv.com",         // PPS
    "https://hsa.claro-stg.clbo-hubtv.com",         // HSA
    "https://ip-location.claro-stg.clbo-hubtv.com", // IP Location
    "https://samlidp-claro-stg.alt.clbo-hubtv.com", // SAML
    "https://sra.claro-stg.clbo-hubtv.com",         // Session Rule Service
    "",                                             // PPV Service
    "https://ap-claro-stg.alt.clbo-hubtv.com")      // Activation Portal
  
  const claroProductionEndPointsCloud = new EnvironmentEndPoints(
    "https://pps.claro-prd.clbo-hubtv.com",         // PPS
    "https://hsa.claro-prd.clbo-hubtv.com",         // HSA
    "https://ip-location.claro-prd.clbo-hubtv.com", // IP Location
    "https://samlidp-claro-prd.alt.clbo-hubtv.com", // SAML
    "https://sra.claro-prd.clbo-hubtv.com",         // Session Rule Service
    "",                                             // PPV Service
    "https://ap-claro-prd.alt.clbo-hubtv.com")      // Activation Portal
///////////////////////////////////////////////

const localEndPoints = new EnvironmentEndPoints(
  "http://127.0.0.1:5001",
  "http://127.0.0.1:5000",
  "http://127.0.0.1:5000",
  "",
  "http://127.0.0.1:5000",
  "http://127.0.0.1:5000",    // PPV Service
  "")    // Activation Portal

  const allEnvironmentEndPointsLlaOnPrem = [
    ["LPR Staging", lprStagingEndPointsOnPrem, "🇵🇷", "#DFE3EE"],
    ["LPR Production", lprProductionEndPointsOnPrem, "🇵🇷", "#DFE3EE"],
    ["CWP Staging", cwpStagingEndPointsOnPrem, "🇵🇦", "#8B9DC3"],
    ["CWP Production", cwpProductionEndPointsOnPrem, "🇵🇦", "#8B9DC3"],
    //["VTR Staging", vtrStagingEndPointsOnPrem, "🇨🇱", "#DFE3EE"],
    //["VTR Staging New", vtrStaging2EndPoints, "🇨🇱", "#DFE3EE"], // Not for cloud
    //["VTR Production", vtrProductionEndPointsOnPrem, "🇨🇱", "#DFE3EE"],
    ["CT Staging", ctStagingEndPointsOnPrem, "🇨🇷", "#8B9DC3"],
    ["CT Production", ctProductionEndPointsOnPrem, "🇨🇷", "#8B9DC3"],
    ["Flow Staging", caribbeanStagingEndPointsOnPrem, "🏝️", "#DFE3EE"],
    ["Flow Production", caribbeanProductionEndPointsOnPrem, "🏝️", "#DFE3EE"],
    ["Local Machine", localEndPoints, "💻", "#8B9DC3"]
  ]
  
const allEnvironmentEndPointsLlaCloud = [
  ["LPR Staging", lprStagingEndPointsCloud, "🇵🇷", "#DFE3EE"],
  ["LPR Production", lprProductionEndPointsCloud, "🇵🇷", "#DFE3EE"],
  ["CWP Staging", cwpStagingEndPointsCloud, "🇵🇦", "#8B9DC3"],
  ["CWP Production", cwpProductionEndPointsCloud, "🇵🇦", "#8B9DC3"],
  //["VTR Staging", vtrStagingEndPointsCloud, "🇨🇱", "#DFE3EE"],
  //["VTR Staging New", vtrStaging2EndPoints, "🇨🇱", "#DFE3EE"], // Not for cloud
  //["VTR Production", vtrProductionEndPointsCloud, "🇨🇱", "#DFE3EE"],
  ["CT Staging", ctStagingEndPointsCloud, "🇨🇷", "#DFE3EE"],
  ["CT Production", ctProductionEndPointsCloud, "🇨🇷", "#DFE3EE"],
  ["Flow Staging", caribbeanStagingEndPointsCloud, "🏝️", "#8B9DC3"],
  ["Flow Production", caribbeanProductionEndPointsCloud, "🏝️", "#8B9DC3"],
  ["LLA Innovation Lab", llaInnoLabEndPointsCloud, "🪄", "#DFE3EE"],
  ["Local Machine", localEndPoints, "💻", "#8B9DC3"]
]

const allEnvironmentEndPointsClaroVtr = [
  //["VTR OnPrem Staging", vtrStagingEndPointsOnPrem, "🇨🇱🏢", "#DFE3EE"],
  //["VTR OnPrem Production", vtrProductionEndPointsOnPrem, "🇨🇱🏢", "#DFE3EE"],
  ["VTR Cloud Staging", vtrStagingEndPointsCloud2, "🇨🇱☁️", "#8B9DC3"],
  ["VTR Cloud Production", vtrProductionEndPointsCloud2, "🇨🇱☁️", "#8B9DC3"],
  ["Claro Cloud Staging", claroStagingEndPointsCloud, "🇨🇱☁️", "#DFE3EE"],
  ["Claro Cloud Production", claroProductionEndPointsCloud, "🇨🇱☁️", "#DFE3EE"],
  ["Local Machine", localEndPoints, "💻", "#8B9DC3"]
]

//const allEnvironmentEndPoints = allEnvironmentEndPointsLlaOnPrem
//const allEnvironmentEndPoints = allEnvironmentEndPointsLlaCloud
const allEnvironmentEndPoints = allEnvironmentEndPointsClaroVtr

function calculateBgColor(latest, current) {
  if (current === "?") { return "#EDEDED" }
  if (current === "-") { return "#939393" }
  if (current === "FAILED") { return "#E54938" }
  if (current === latest) { return "#56A151"  } 

  return "#F9BA39"
}

function CountryServices({ environmentName, countryEndPoints, flag, color }) {
  return (
    <tr align="left">
      <td width="30" align="center" bgcolor={color}>{flag}</td>
      <td bgcolor={color}>{environmentName}</td>
      <td align="center" bgcolor={calculateBgColor(ppsCurrentVersion, countryEndPoints.pps.version)}><a href={countryEndPoints.pps.url_version}>url</a><br /><a href={countryEndPoints.pps.url_config}>config</a><br />version: {countryEndPoints.pps.version}</td>
      <td align="center" bgcolor={calculateBgColor(ipLocationCurrentVersion, countryEndPoints.ipLocation.version)}><a href={countryEndPoints.ipLocation.url_version}>url</a><br /><a href={countryEndPoints.ipLocation.url_config}>config</a><br />version: {countryEndPoints.ipLocation.version}</td>
      <td align="center" bgcolor={calculateBgColor(hubTvSupportApiCurrentVersion, countryEndPoints.hubTvSupportApi.version)}><a href={countryEndPoints.hubTvSupportApi.url_version}>url</a><br /><a href={countryEndPoints.hubTvSupportApi.url_config}>config</a><br />version: {countryEndPoints.hubTvSupportApi.version}</td> 
      <td align="center" bgcolor={calculateBgColor(samlCurrentVersion, countryEndPoints.saml.version)}><a href={countryEndPoints.saml.url_version}>url</a><br/>config<br/>version: {countryEndPoints.saml.version}</td> 
      <td align="center" bgcolor={calculateBgColor(sessionRuleServiceCurrentVersion, countryEndPoints.sessionRuleService.version)}><a href={countryEndPoints.sessionRuleService.url_version}>url</a><br/>config<br/>version: {countryEndPoints.sessionRuleService.version}</td> 
      <td align="center" bgcolor={calculateBgColor(ppvServiceCurrentVersion, countryEndPoints.ppvService.version)}><a href={countryEndPoints.ppvService.url_version}>url</a><br/>config<br/>version: {countryEndPoints.ppvService.version}</td> 
      <td align="center" bgcolor={calculateBgColor(activationPortalCurrentVersion, countryEndPoints.activationPortal.version)}><a href={countryEndPoints.activationPortal.url_version}>url</a><br/>config<br/>version: {countryEndPoints.activationPortal.version}</td> 
    </tr>)
}

function App() {
  const [environments, setEnvironments] = React.useState(allEnvironmentEndPoints)

  function getAllVersion() {

    for (let i = 0; i < environments.length; i++) {
      // Check the PPS Version
      if (environments[i][1].pps.url_version.search('version') > -1){ 
        const newEnvironments = [...environments]
        newEnvironments[i][1].pps.version = "Loading";
        setEnvironments(newEnvironments)
        axios.get(environments[i][1].pps.url_version)
          .then(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].pps.version = res.data.version;
            setEnvironments(newEnvironments)
            console.log(newEnvironments[i][1].pps.url_version + ' ==> '+ newEnvironments[i][1].pps.version)
            
          }).catch(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].pps.version = "FAILED";
            setEnvironments(newEnvironments)
            console.log('FAILED: ' + newEnvironments[i][1].pps.url_version)
          })
      }
      // Check the IP Location Version
      if (environments[i][1].ipLocation.url_version.search('version') > -1){
        const newEnvironments = [...environments]
        newEnvironments[i][1].ipLocation.version = "Loading";
        setEnvironments(newEnvironments)
        axios.get(environments[i][1].ipLocation.url_version)
          .then(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].ipLocation.version = res.data.version;
            setEnvironments(newEnvironments)
            console.log(newEnvironments[i][1].ipLocation.url_version + ' ==> '+ newEnvironments[i][1].ipLocation.version)
            
          }).catch(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].ipLocation.version = "FAILED";
            setEnvironments(newEnvironments)
            console.log('FAILED: ' + newEnvironments[i][1].ipLocation.url_version)
          })
      }
      // Check the HubTV Support Proxy Version
      if (environments[i][1].hubTvSupportApi.url_version.search('version') > -1){
        const newEnvironments = [...environments]
        newEnvironments[i][1].hubTvSupportApi.version = "Loading";
        setEnvironments(newEnvironments)
        axios.get(environments[i][1].hubTvSupportApi.url_version)
          .then(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].hubTvSupportApi.version = res.data.version;
            setEnvironments(newEnvironments)
            console.log(newEnvironments[i][1].hubTvSupportApi.url_version + ' ==> '+ res.data.version)
            
          }).catch(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].hubTvSupportApi.version = "FAILED";
            setEnvironments(newEnvironments)
            console.log('FAILED: ' + newEnvironments[i][1].hubTvSupportApi.url_version)
          })
      }
      // Check the SAML/IDP Version
      if (environments[i][1].saml.url_version.search('version') > -1){
        const newEnvironments = [...environments]
        newEnvironments[i][1].saml.version = "Loading";
        setEnvironments(newEnvironments)
        axios.get(environments[i][1].saml.url_version)
          .then(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].saml.version = res.data.version;
            setEnvironments(newEnvironments)
            console.log(newEnvironments[i][1].saml.url_version + ' ==> '+ res.data.version)
            
          }).catch(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].saml.version = "FAILED";
            setEnvironments(newEnvironments)
            console.log('FAILED: ' + newEnvironments[i][1].saml.url_version)
          })
      }
      // Check the Session Rule Service Version
      if (environments[i][1].sessionRuleService.url_version.search('version') > -1){
        const newEnvironments = [...environments]
        newEnvironments[i][1].sessionRuleService.version = "Loading";
        setEnvironments(newEnvironments)
        axios.get(environments[i][1].sessionRuleService.url_version)
          .then(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].sessionRuleService.version = res.data.version;
            setEnvironments(newEnvironments)
            console.log(newEnvironments[i][1].sessionRuleService.url_version + ' ==> '+ res.data.version)
            
          }).catch(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].sessionRuleService.version = "FAILED";
            setEnvironments(newEnvironments)
            console.log('FAILED: ' + newEnvironments[i][1].sessionRuleService.url_version)
          })
      }
      // Check the PPV Service Version
      if (environments[i][1].ppvService.url_version.search('version') > -1){
        const newEnvironments = [...environments]
        newEnvironments[i][1].ppvService.version = "Loading";
        setEnvironments(newEnvironments)
        axios.get(environments[i][1].ppvService.url_version)
          .then(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].ppvService.version = res.data.version;
            setEnvironments(newEnvironments)
            console.log(newEnvironments[i][1].ppvService.url_version + ' ==> '+ res.data.version)
            
          }).catch(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].ppvService.version = "FAILED";
            setEnvironments(newEnvironments)
            console.log('FAILED: ' + newEnvironments[i][1].ppvService.url_version)
          })
      }
      // Check the Activation Portal
      if (environments[i][1].activationPortal.url_version.search('version') > -1){
        const newEnvironments = [...environments]
        newEnvironments[i][1].activationPortal.version = "Loading";
        setEnvironments(newEnvironments)
        axios.get(environments[i][1].activationPortal.url_version)
          .then(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].activationPortal.version = res.data.version;
            setEnvironments(newEnvironments)
            console.log(newEnvironments[i][1].activationPortal.url_version + ' ==> '+ res.data.version)
            
          }).catch(res => {
            const newEnvironments = [...environments]
            newEnvironments[i][1].activationPortal.version = "FAILED";
            setEnvironments(newEnvironments)
            console.log('FAILED: ' + newEnvironments[i][1].activationPortal.url_version)
          })
      }
    }
  }

  return (
    <div className="App">
      <h1>HubTV Microservice Version Checker</h1>
      <button onClick={getAllVersion}>Check all version</button><hr/>
      <table align="center">
        <thead>
          <tr>
            <th width="130" colspan="2" align="center" style={{verticalAlign: "middle"}} bgcolor="lightgrey">Environment</th>
            <th width="130">PPS<br />({ppsCurrentVersion})
              <br />
              <a href="https://llabo-gitlab.mw.columbuscdn.com/backoffice/hubtv/microservices/lla_partner_provisioning_service">git</a>
            </th>
            <th width="130">IP Location<br />({ipLocationCurrentVersion})
              <br />
              <a href="https://llabo-gitlab.mw.columbuscdn.com/backoffice/hubtv/microservices/lla_ip_location">git</a>
            </th>
            <th width="130">HubTV Support API<br />({hubTvSupportApiCurrentVersion})
              <br />
              <a href="https://llabo-gitlab.mw.columbuscdn.com/backoffice/hubtv/microservices/lla_hubtv_support_api">git</a>
            </th>
            <th width="130">SAML/IDP<br />({samlCurrentVersion})
              <br />
              <a href="https://llabo-gitlab.mw.columbuscdn.com/backoffice/hubtv/microservices/lla_saml">git</a>
            </th>
            <th width="130">Session Rule Service<br />({sessionRuleServiceCurrentVersion})
              <br />
              <a href="https://llabo-gitlab.mw.columbuscdn.com/backoffice/hubtv/microservices/lla_session_rule">git</a>
            </th>
            <th width="130">PPV Service<br />({ppvServiceCurrentVersion})
              <br />
              <a href="https://llabo-gitlab.mw.columbuscdn.com/backoffice/hubtv/microservices/lla_pay_per_view">git</a>
            </th>
            <th width="130">Activation Portal<br />({activationPortalCurrentVersion})
              <br />
              <a href="https://llabo-gitlab.mw.columbuscdn.com/backoffice/hubtv/microservices/lla_activation_portal">git</a>
            </th>
          </tr>
        </thead>

        <tbody>
          {environments.map(environment => (
            <CountryServices environmentName={environment[0]} countryEndPoints={environment[1]} flag={environment[2]} color={environment[3]} />
          ))}
        </tbody>

      </table>

      
    </div>
  );
}

export default App;
